import React, { useState, useRef } from "react";
import { isOverflowing } from "@/util/common";
import { CollapsibleText, AgencyRowEntry, ActionText } from "./AgencyRow.styled";
import { Box } from "@thecb/components";
import { ALL_AGENCIES } from "../../AdministeredUsers.state";

const AgencyRow = ({
  hasAllAgencies,
  agencies,
  maxWidth,
  isExpanded,
  onToggleExpanded,
}) => {
  const [internalExpanded, setInternalExpanded] = useState(false);
  const isControlled = isExpanded !== undefined;
  const expanded = isControlled ? isExpanded : internalExpanded;

  const agencyText = hasAllAgencies
    ? ALL_AGENCIES
    : agencies.length > 0
      ? agencies.join(", ")
      : "No agencies";
  const textRef = useRef();
  const expandable = isOverflowing(textRef);
  const toggleExpanded = (event) => {
    event.stopPropagation();
    if (isControlled) {
      onToggleExpanded?.();
    } else {
      setInternalExpanded(!internalExpanded);
    }
  };

  return (
    <AgencyRowEntry expanded={expanded} maxWidth={maxWidth}>
      <CollapsibleText expanded={expanded} maxWidth={maxWidth} ref={textRef}>
        {agencyText}
        {expandable && expanded && (
          <ActionText
            onClick={toggleExpanded}
            margin={"0 0 0 8px"}
            data-qa="agency-row-less"
          >
            Less
          </ActionText>
        )}
      </CollapsibleText>
      {expandable && !expanded && (
        <Box padding="0">
          <ActionText
            onClick={toggleExpanded}
            margin={"0 0 0 8px"}
            data-qa="agency-row-more"
          >
            More
          </ActionText>
        </Box>
      )}
    </AgencyRowEntry>
  );
};

export default AgencyRow;
